import { render, staticRenderFns } from "./UISelectItem.vue?vue&type=template&id=021c8072&lang=html"
import script from "./UISelectItem.vue?vue&type=script&lang=js"
export * from "./UISelectItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports